import React from "react";
import { Link } from "react-router-dom";
import Navbar from '../Navbar/Navbar.jsx';
import PrimaryActionButton from '../PrimaryActionButton/PrimaryActionButton';

import logo from '../../assets/images/logo.svg';

const Header = () => {

  return (
    <div className="m-5 mt-2 header">
      <div className="flex justify-start lg:justify-between items-center">
        <div className="w-1/3">
          <Navbar />
        </div>
        <div className="w-1/3">
          <Link to="/">
            <img src={logo} className="logo" alt="metafans logo" />
          </Link>
        </div>
        <div className="w-1/3 lg:hidden"></div>
        <div className="hidden lg:flex w-1/3 flex-col-reverse md:flex-row justify-center md:justify-end items-center">
          <PrimaryActionButton />
        </div>
      </div>
    </div>
  );
};

export default Header;